import { render } from "./ImagemToBase64.vue?vue&type=template&id=4b3c0fdc&scoped=true"
import script from "./ImagemToBase64.vue?vue&type=script&lang=js"
export * from "./ImagemToBase64.vue?vue&type=script&lang=js"

import "./ImagemToBase64.vue?vue&type=style&index=0&id=4b3c0fdc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b3c0fdc"]])

export default __exports__